import React from 'react';

const SCAN_TYPES = [
  'Chest X-ray',
  'Brain MRI',
  'Spine MRI',
  'Knee / Joint X-ray',
  'Skin condition',
  'Abdominal scan',
  'Other',
];

/**
 * Optional patient context form: age, scan type, and symptoms.
 */
export default function ContextForm({ age, setAge, scanType, setScanType, symptoms, setSymptoms }) {
  return (
    <div className="mt-6 space-y-4">
      <h2 className="text-base font-semibold text-gray-700">
        Patient context <span className="font-normal text-gray-400">(optional)</span>
      </h2>

      {/* Age + Scan type — two columns */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-600 mb-1" htmlFor="age">
            Age
          </label>
          <input
            id="age"
            type="number"
            min="0"
            max="120"
            placeholder="e.g. 42"
            value={age}
            onChange={(e) => setAge(e.target.value)}
            className="w-full rounded-xl border border-gray-200 px-4 py-2.5 text-sm text-gray-800 placeholder-gray-400
                       focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-600 mb-1" htmlFor="scanType">
            Scan type
          </label>
          <select
            id="scanType"
            value={scanType}
            onChange={(e) => setScanType(e.target.value)}
            className="w-full rounded-xl border border-gray-200 px-4 py-2.5 text-sm text-gray-800
                       focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition bg-white"
          >
            <option value="">Select scan type…</option>
            {SCAN_TYPES.map((type) => (
              <option key={type} value={type}>
                {type}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Symptoms — full width */}
      <div>
        <label className="block text-sm font-medium text-gray-600 mb-1" htmlFor="symptoms">
          Symptoms or concerns
        </label>
        <textarea
          id="symptoms"
          rows={3}
          placeholder="Describe any symptoms, pain, or concerns you have…"
          value={symptoms}
          onChange={(e) => setSymptoms(e.target.value)}
          className="w-full rounded-xl border border-gray-200 px-4 py-2.5 text-sm text-gray-800 placeholder-gray-400
                     focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition resize-none"
        />
      </div>
    </div>
  );
}
